var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExitfullscreenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exit-full-screen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7 0.05C8.65 0 8.55 0 8.5 0L1.5 0C1.2 0 1 0.2 1 0.5C1 0.8 1.2 1 1.5 1L7.3 1L0.15 8.15C-0.05 8.35 -0.05 8.65 0.15 8.85C0.25 8.95 0.4 9 0.5 9C0.6 9 0.75 8.95 0.85 8.85L8 1.7L8 7.5C8 7.8 8.2 8 8.5 8C8.8 8 9 7.8 9 7.5L9 0.5C9 0.45 9 0.35 8.95 0.3C8.9 0.2 8.8 0.1 8.7 0.05Z",
    transform: "translate(0 13)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85 0.15C8.65 -0.05 8.35 -0.05 8.15 0.15L1 7.3L1 1.5C1 1.2 0.8 1 0.5 1C0.2 1 0 1.2 0 1.5L0 8.5C0 8.55 0 8.65 0.05 8.7C0.1 8.8 0.2 8.9 0.3 8.95C0.35 9 0.45 9 0.5 9L7.5 9C7.8 9 8 8.8 8 8.5C8 8.2 7.8 8 7.5 8L1.7 8L8.85 0.85C9.05 0.65 9.05 0.35 8.85 0.15Z",
    transform: "translate(13 0)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitfullscreenIcon);
export default __webpack_public_path__ + "static/media/ExitfullscreenIcon.8ffd7bba.svg";
export { ForwardRef as ReactComponent };